var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"loader",attrs:{"src":require("@/assets/loader.svg"),"alt":"Loader"}})}
var staticRenderFns = []

export { render, staticRenderFns }